import { ChipTypeEnums } from "constants/enums";

/**
 * Maps a Model Task filter chips array ({ chipType, id, value }) to the
 * search params the paged task list endpoint expects. A chipType of
 * Undefined is the free-text "Contains" chip (added via Enter in the search
 * box) and becomes the `search` string; only the most recently added one
 * counts, since the UI only ever keeps one active at a time.
 */
export const processModelTaskChipsForAPI = (chips = []) => {
	const params = {
		search: "",
		roleIds: [],
		intervalIds: [],
		zoneIds: [],
		stageIds: [],
		arrangementIds: [],
	};

	if (!Array.isArray(chips)) {
		return params;
	}

	chips.forEach((chip) => {
		if (chip.chipType === ChipTypeEnums.Undefined) {
			if (chip.value) params.search = chip.value;
			return;
		}

		if (chip.id == null) return;
		const id = parseInt(chip.id);
		switch (chip.chipType) {
			case ChipTypeEnums.Role:
				params.roleIds.push(id);
				break;
			case ChipTypeEnums.Interval:
				params.intervalIds.push(id);
				break;
			case ChipTypeEnums.Zone:
				params.zoneIds.push(id);
				break;
			case ChipTypeEnums.Stage:
				params.stageIds.push(id);
				break;
			case ChipTypeEnums.Arrangement:
				params.arrangementIds.push(id);
				break;
			default:
				break;
		}
	});

	return params;
};
